import { render, staticRenderFns } from "./UnidadeAdministrativaTab.vue?vue&type=template&id=a3168a02"
import script from "./UnidadeAdministrativaTab.vue?vue&type=script&lang=js"
export * from "./UnidadeAdministrativaTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports